import { Component, ElementRef, OnInit, OnDestroy, ViewChild } from '@angular/core'
import { Location } from "@angular/common"
import { Course } from '../course.model';
import { CourseService } from '../course.service';
import { UserService } from '../user.service';
import { ActivatedRoute, Router } from "@angular/router"
// import { SURVEY_GIZMO_SAML_LOGIN_URL } from '../../constants'

@Component({
    selector: 'app-detail',
    templateUrl: './detail.component.html',
    styleUrls: ['./detail.component.scss'],
})
export class DetailComponent implements OnInit, OnDestroy {
    // @ViewChild('registrations') registrationsRef
    // @ViewChild('olr2Registrations') olr2RegistrationsRef
    // @ViewChild('logs') logsChildRef

    defaultDisplay = false;
    // defaultDisplay = true;

    constructor(
        private courseService: CourseService,
        private userService: UserService,
        private route: ActivatedRoute,
        private router: Router,
        private location: Location,
        private elementRef: ElementRef,
    ) {}

    ngOnInit(): void {
        if ( !this.userService.isAdmin ) {
            this.userService.deny();
            return;
        }

        this.courseService.isEditable =
            this.router.url.endsWith('/add') ||
            this.router.url.endsWith('/edit');

        this.courseService.display = this.courseService.isEditable;

        let id = this.route.snapshot.paramMap.get('id');

        this.courseService.course = new Course({
            id: id ? parseInt(id) : null,
        });

        this.courseService.get();
    }

    ngOnDestroy() {
        // console.log(`clean up detail component`)
        this.elementRef.nativeElement.remove();
        this.courseService.ngOnDestroy();
    }

    add() {
        if (this.course.id) {
            this.courseService.add();
            this.location.replaceState(`/admin/courses-and-events/${this.course.id}`);
            return;
        }
        this.router.navigate([`/admin/courses-and-events/add`]);
    }

    edit() {
        this.location.replaceState(`/admin/courses-and-events/${this.course.id}/edit`);
        this.courseService.edit();
    }

    cancel() {
        if (this.course.id) {
            this.courseService.reset();
            this.location.replaceState(`/admin/courses-and-events/${this.course.id}`);
            return;
        }
        // this.courseService
        this.router.navigate(['/admin/courses-and-events/']);
        // location.href = '/admin/courses-and-events/';

    }

    save() {
        this.courseService.save();
    }

    delete() {
        if (
            confirm(
                `Are you sure you would like to delete this course for ${this.course.name} (${this.course.id})?`
            )
        ) {
            this.courseService.delete();
        }
    }
    
    open(url){ 
        window.open(url, "_blank")
    }

    get isAuthorized() {
        return this.userService.isAuthorized;
    }

    get isAdmin() {
        return this.userService.isAdmin;
    }

    get isSuperAdmin() {
        return this.userService.isSuperAdmin;
    }

    get isEditable() {
        return this.courseService.isEditable;
    }

    get isLoaded() {
        return this.courseService.isLoaded;
    }

    get isLoading() {
        return this.courseService.isLoading;
    }

    get isSaving() {
        return this.courseService.isSaving;
    }

    get isDeleting() {
        return this.courseService.isDeleting;
    }

    get errorMessage() {
        return this.courseService.errorMessage;
    }

    get course() {
        return this.courseService.course;
    }

    // onRefreshRegistrations(refreshRegistrations: boolean) {
    //     this.registrationsRef.getRegistrations()
    // }

    // onRefreshOlr2Registrations(refreshOlr2Registrations: boolean) {
    //     this.olr2RegistrationsRef.getOlr2Registrations()
    // }

    // onRefreshLogs(refreshLogs: boolean){
    //     this.logsChildRef.getLogs()
    // }

}
